export default "__VITE_ASSET__CTDoJtzT__"